function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#E8EAEC"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M40.111 10.556c-1.166 0-2.111.945-2.111 2.11v12.667c0 2.328-1.894 4.223-4.222 4.223H14.105V25.35L3.167 31.667l10.938 6.316v-4.205h19.673c4.656 0 8.444-3.788 8.444-8.445V12.667c0-1.166-.945-2.111-2.11-2.111zM4.222 25.333V12.667c0-2.328 1.894-4.223 4.222-4.223h19.674v4.205l10.938-6.316L28.118.017v4.205H8.444C3.788 4.222 0 8.01 0 12.667v12.666c0 1.166.945 2.111 2.111 2.111 1.166 0 2.111-.945 2.111-2.11z",
  transform: "translate(-1026 -463) translate(762 266) translate(23 135) translate(56 62) translate(185.889)"
})))))));

var SvgIconProcessingVideo = function SvgIconProcessingVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProcessingVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-processing-video.85d755c9.svg";
export { ForwardRef as ReactComponent };